import React from "react";
import LoginForm from "../../components/LoginForm";
// import LoginCabang from '../../components/loginBranch';
import { Card, Row, Col } from "antd";
import { useSelector } from "react-redux";

const backgroundStyle = {
  backgroundImage: "url(/img/others/img-17.jpg)",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
};

const cardStyle = {
  borderRadius: "16px",
  marginRight: "24px",
  boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)",
};

const Login = (props) => {
  const theme = useSelector((state) => state.theme.currentTheme);
  return (
    <div className="h-100" style={backgroundStyle}>
      <div className="container d-flex flex-column justify-content-center h-100">
        <Row justify="center">
          <Col xs={20} sm={20} md={20} lg={9}>
            {/* <Card style={cardStyle}> */}
            <Card>
              <div className="my-4">
                <div className="text-center mb-4">
                  <img
                    className="img-fluid"
                    src={`/img/${theme === "light"
                        ? "logoFintrust.png"
                        : "logoFintrust.png"
                      }`}
                    alt=""
                  />
                </div>
                <Row justify="center">
                  <Col xs={24} sm={24} md={20} lg={20}>
                    <LoginForm {...props} />
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Login;
